import { Link } from "react-router-dom";
import { Sun, Moon, TerminalSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO = "https://customer-assets.emergentagent.com/job_entry-portal-77/artifacts/xymzqll8_ChatGPT%20Image%20Jul%2010%2C%202026%2C%2011_17_26%20AM.png";

export const NavBar = ({ dark, toggleTheme }) => (
  <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur-xl">
    <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
      <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
        <img src={LOGO} alt="DockBox" className="w-9 h-9 rounded-lg" />
        <span className="font-heading font-semibold tracking-tight text-lg">DockBox</span>
        <span className="hidden sm:inline font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground border border-border rounded-full px-2 py-0.5">
          checkout-in-a-box
        </span>
      </Link>
      <div className="flex items-center gap-2">
        <Button asChild variant="ghost" size="sm" data-testid="nav-admin-link">
          <Link to="/admin" className="gap-2">
            <TerminalSquare className="w-4 h-4" />
            <span className="hidden sm:inline">Developer</span>
          </Link>
        </Button>
        <Button variant="outline" size="icon" onClick={toggleTheme} data-testid="theme-toggle-btn" className="rounded-full">
          {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
      </div>
    </div>
  </header>
);
